import $ from 'jquery';
import { GetElement, RemoveAttr, SetAttr } from '@/libs/util';

export type ExistsElement = (selector: string) => boolean;
type InvokeUpdateCurrentPrice = (
  selector: string,
  wcSelector: string,
  existsElement: ExistsElement
) => (updateCurrentPrice: CallableFunction) => void;
type UpdateGlobalVariableByElement = (
  selector: string,
  existsElement: ExistsElement,
  wcSelector: string,
  getElement: GetElement,
  globalObj: any,
  propertyName: string,
  attr: string,
  updateGlobalVariable: UpdateGlobalVariable
) => () => void;
export type SetContentToElement = (selector: string, content: string) => void;
export type UpdateGlobalVariable = (
  globalObj: any,
  propertyName: string,
  value: number
) => void;

/**
 * 要素が存在するかどうか
 *
 * @param  selector 存在の確認を行う要素のセレクタ
 * @returns 要素が存在するかどうか
 */
export const existsElement: ExistsElement = (selector) => {
  const element = document.querySelector(selector);
  return element !== null;
};

/**
 * 対象の要素が存在したときに、updateCurrentPriceを実行する
 *
 * @param selector 存在の確認を行う要素のセレクタ
 * @param wcSelector 存在の確認を行うwc要素のセレクタ
 * @param existsElement 要素が存在するかどうかの確認を行う関数
 */
export const invokeUpdateCurrentPrice: InvokeUpdateCurrentPrice = (
  selector,
  wcSelector,
  existsElement
) => (updateCurrentPrice) => {
  if (!existsElement(selector) && !existsElement(wcSelector)) return;
  updateCurrentPrice();
};

/**
 * 要素のテキストから数値を抽出し任意のオブジェクトのプロパティに代入する
 *
 * @param selector 存在の確認を行う要素のセレクタ
 * @param existsElement 要素が存在するかどうかの確認を行う関数
 * @param getElement WC要素の取得を行う関数
 * @param wcSelector 存在の確認を行うwc要素のセレクタ
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param attr 値を取得する属性
 * @param updateGlobalVariable 指定したグローバル変数を更新する関数
 */
export const updateGlobalVariableByElement: UpdateGlobalVariableByElement = (
  selector,
  existsElement,
  wcSelector,
  getElement,
  globalObj,
  propertyName,
  attr,
  updateGlobalVariable
) => () => {
  const element = getElement(wcSelector);
  if (element) {
    const attrValue = element.getAttribute(attr);
    if (!attrValue) return;
    updateGlobalVariable(
      globalObj,
      propertyName,
      parseInt(attrValue.replace(/[^0-9]/g, ''))
    );
  }
  if (existsElement(selector)) {
    updateGlobalVariable(
      globalObj,
      propertyName,
      parseInt(
        $(selector)
          .text()
          .replace(/[^0-9]/g, '')
      )
    );
  }
};

/**
 * 指定した要素のテキストを書き換える
 
 * @param selector 指定した要素
 * @param content 書き換えるテキスト
 */
export const setContentToElement: SetContentToElement = (selector, content) => {
  $(selector).html(content);
};

/**
 * 指定したグローバル変数を更新する
 *
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param value 更新する値
 */
export const updateGlobalVariable: UpdateGlobalVariable = (
  globalObj,
  propertyName,
  value
) => {
  globalObj[propertyName] = value;
};
